<template>
  <el-dialog
    :visible.sync="show"
    custom-class="signupDialog"
    :close-on-press-escape="false"
    :show-close="false"
    :before-close="closeDialog"
    >
    <div class="first-floor">
      <div class="label">
        <span class="title required">收件人姓名：</span>
        <el-input v-model="form.link_name" placeholder="请输入姓名"></el-input>
      </div>
      <div class="label">
        <span class="title required">收件人手机：</span>
        <el-input v-model="form.link_mobile" placeholder="请输入手机号" maxlength="11"></el-input>
      </div>
    </div>
    <div class="first-floor">
      <div class="label">
        <span class="title required">收件人地址：</span>
        <el-input v-model="form.link_addr" placeholder="请输入收件人地址"></el-input>
      </div>
      <div class="label">
        <span class="title">推荐人手机（推荐人需注册）：</span>
        <el-input v-model="form.recommend_mobile" placeholder="请输入推荐人手机号" maxlength="11"></el-input>
      </div>
    </div>
    <div class="first-floor">
      <div class="label">
        <span class="title required">购买金额：</span>
        <el-input v-model="form.amount_money" type="tel" placeholder="请输入购买金额" @input="formatteInput"></el-input>
      </div>
      <div class="label">
        <span class="title required">购买门店：</span>
        <el-cascader
					v-model="shop"
					:options="shopList"
          separator="-"
					popper-class="popperinp2"
          @change="selectedCity"
        >
        </el-cascader>
      </div>
    </div>
    <div class="product-box">
      <div class="products-template" v-for="(item, index) in this.form.products" :key="index">
        <div class="products-content">
          <div class="first-floor">
            <div class="label">
              <span class="title required">使用产品：</span>
              <el-select v-model="form.products[index].product" placeholder="请选择" popper-class="popperinp2">
                <el-option
                  v-for="item in productList"
                  :key="item.prod"
                  :label="item.prod"
                  :value="item.prod">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="first-floor">
            <div class="label">
              <span class="title required">产品花色：</span>
              <el-select v-model="form.products[index].model" placeholder="请选择" popper-class="popperinp2" :disabled="!form.products[index].product" @focus="changeColorList(index)">
                <el-option
                  v-for="(item, index) in colorList"
                  :key="item + index"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="operatBtn">
          <img v-if="form.products.length != 1 && index != form.products.length - 1" src="@/assets/serve/activity/cut.png" @click="removeProduct(index)">
          <img v-if="index == form.products.length - 1" src="@/assets/serve/activity/add.png" alt="" srcset="" @click="addProduct">
        </div>
      </div>
    </div>
    <div class="first-floor anotherfloor">
      <div class="label anotherlabel">
        <span class="title required">秀图 (图片大小不超过5M)</span>
        <div class="image-box">
          <template v-for="(item, index) in form.photos">
            <div v-if="form.photos.length > 0" class="img-content" :key="index">
              <img :src="item.pic_url" class="card" :key="index" >
              <img class="close-icon" src="@/assets/serve/designer/close-icon.png" alt="" srcset="" @click="deleteImg(index)">
            </div>
          </template>
          <el-upload
            class="visiting-card-uploader"
            action="#"
            :show-file-list="false"
            :http-request="afterReadPhoto">
            <img class="card-default" src="@/assets/serve/designer/camera-icon.png">
          </el-upload>
        </div>
      </div>
    </div>
    <div class="first-floor rowfloor">
      <div class="label">
        <span class="title required">满意度评分：</span>
        <el-rate v-model="form.grade" :colors="['#ED381A', '#ED381A', '#ED381A']"></el-rate>
      </div>
    </div>
    <div class="first-floor">
      <div class="label">
        <span class="title required">评价及建议：</span>
        <el-input type="textarea" :rows="6" resize="none" v-model="form.comment"></el-input>
      </div>
    </div>
    <el-button class="signupBtn" type="success" :loading="isloading" @click="submitForm">{{isloading ? '提交中...' : '提交'}}</el-button>
  </el-dialog>
</template>

<script>
import { upload, productList, shopList } from '@/api/tools.js'
import { addActivityCase, searchChkMobile, updateActivityCase } from '@/api/case.js'
import { isPhone } from '@/util/utils.js'
export default {
  name: 'activitySignup',
  components:{ 
  },
  props: {
    info: {},
    userInfo: {}, 
    show: false
  },
  data() {
    return {
      isloading: false,
      form: {
        user_type: this.userInfo.user_type || null,
        link_name: '', // 收件人姓名
        link_mobile: '', // 收件人手机
        link_addr: '', // 收件地址
        recommend_mobile: '', // 推荐人手机
        amount_money: '', // 购买金额
        province: '',
        shop: '', // 购买门店
        products: [
          {
            product: '',
            model: ''
          }
        ], // 购买产品
        photos: [],
        grade: 0,
        comment: ''
      },
      shop: '',
      shopList: [],
      productList: [],
      colorList: []
    }
  },
  computed:{ },
  watch: {
  },
  created() {
    this.getproductList()
    this.getshopList()
    console.log(213123, this.info)
    if (this.info) {
      this.form = {...this.form, ...this.info}
      this.form.photos = JSON.parse(this.form.photos)
      this.form.products = JSON.parse(this.form.products)
      this.form.amount_money = (this.form.amount_money * 0.01).toFixed(2)
    }
  },
  mounted() {
  },
  methods: {
    formatteInput(value) {
      this.form.amount_money = value.replace(/[^\d.]/,'').replace(/\.\d{2,}$/, value.substr(value.indexOf('.'), 3))
    },

    getshopList() {
      shopList().then(res => {
        res.map(item => {
          item.value = item.province
          item.label = item.province
          item.children = item.shopList
          item.children = item.shopList.map(childe => {
            const json = {
              value: childe,
              label: childe
            }
            childe = json
            return  childe
          })
          return item
        })
        this.shopList = res
        if (this.info) {
          const val1 = this.shopList.filter(item => item.label === this.form.province)[0].value
          const val2 = this.shopList.filter(item => item.label === this.form.province)[0].children.filter(secondItems => secondItems.label === this.form.shop)[0].value
          this.shop = [val1, val2]
        }
      })
    },

    getproductList() {
      productList().then((res) => {
        this.productList = res
      })
    },

    changeColorList(index) {
      this.colorList = this.productList.filter(item => item.prod === this.form.products[index].product)[0].colList || []
    },

    selectedCity(val) {
      this.form.province = val[0]
      this.form.shop = val[1]
    },

    // 新增购买产品
    addProduct() {
      this.form.products.push({ product: '', model: '' })
    },

    // 删除购买产品
    removeProduct(index) {
      this.form.products.splice(index, 1)
    },

    // 上传封面
    afterReadtitle(file) {
      upload(file.file).then((res) => {
        if (res.result === 1) {
          this.form.title_pic = res.fileLink
        } else {
          this.$message(res.msg)
        }
      }).catch((err) => console.log(err))
    },

    // 上传案例
    afterReadPhoto(file) {
      upload(file.file).then((res) => {
        if (res.result === 1) {
          const obj = {
            pic_url: res.fileLink,
            url: res.fileLink,
          }
          this.form.photos.push(obj)
        } else {
          this.$message(res.msg)
        }
      }).catch((err) => console.log(err))
    },

    deleteImg(index) {
      this.form.photos.splice(index, 1)
    },

    submitForm() {
      this.isloading = true
      if (!this.form.link_name) {
        this.isloading = false
        this.$message('请输入收件人姓名')
        return
      }
      if (!isPhone(this.form.link_mobile)) {
        this.isloading = false
        this.$message('手机号格式不正确')
        return
      }
      if (!this.form.link_addr)  {
        this.isloading = false
        this.$message('请输入收件人地址')
        return
      }
      if (this.form.amount_money === '') {
        this.isloading = false
        this.$message('请输入购买金额')
        return
      }
      if (!this.form.shop) {
        this.isloading = false
        this.$message('请选择购买门店')
        return
      }
      if (this.form.photos.length <=0 ) {
        this.isloading = false
        this.$message('请上传秀图')
        return
      }
      if (!this.form.comment) {
        this.isloading = false
        this.$message('请输入评价及建议')
        return
      }
      this.form.products.map(item => {
        if (item.product === '')  {
          this.isloading = false
          this.$message('请选择使用产品')
          return
        }
        if (item.model === '')  {
          this.isloading = false
          this.$message('请选择产品花色')
          return
        }
        return
      })
      if (this.form.recommend_mobile) {
        if (!isPhone(this.form.recommend_mobile)) {
          this.showloading = false
          this.$message('请输入正确的推荐人手机')
        } else {
          searchChkMobile({
            mobile: this.form.recommend_mobile
          }).then(res => {
            if (res.result === 0) {
              this.showloading = false
              this.$message('请输入正确的推荐人手机')
              return false
            } else {
              if (this.info) {
                updateActivityCase({ ...this.form }).then(res => {
                  if (res.result === 1) {
                    this.showloading = false
                    this.$message({
                      message: '保存成功',
                      type: 'success'
                    });
                    this.isloading = false
                    this.$emit('refresh')
                    this.$emit('close', false)
                  } else {
                    this.showloading = false
                    this.$message(res.msg)
                  }
                })
              } else {
                addActivityCase({ ...this.form }).then(res => {
                  if (res.result === 1) {
                    this.$message({
                      message: '提交成功',
                      type: 'success'
                    });
                    this.isloading = false
                    this.$emit('refresh')
                    this.$emit('close', false)
                    this.$emit('success', true)
                  } else {
                    this.showloading = false
                    this.$message(res.msg)
                  }
                }).catch(err => {
                  console.log(err)
                })
              }
            }
          })
        }
      } else {
        if (this.info) {
          updateActivityCase({ ...this.form }).then(res => {
            if (res.result === 1) {
              this.showloading = false
              this.$message({
                message: '保存成功',
                type: 'success'
              });
              this.isloading = false
              this.$emit('refresh')
              this.$emit('close', false)
            } else {
              this.showloading = false
              this.$message(res.msg)
            }
          })
        } else {
          addActivityCase({ ...this.form }).then(res => {
            if (res.result === 1) {
              this.$message({
                message: '提交成功',
                type: 'success'
              });
              this.isloading = false
              this.$emit('refresh')
              this.$emit('close', false)
              this.$emit('success', true)
            } else {
              this.showloading = false
              this.$message(res.msg)
            }
          }).catch(err => {
            console.log(err)
          })
        }
      }
    },
    closeDialog() {
      this.form = {
        user_type: this.userInfo.user_type || null,
        creation_name: '', // 案例名称
        province: '', // 省
        city: '', // 市
        area: '', // 建筑面积
        // 使用产品 产品花色
        products: [
          {
            product: '',
            model: ''
          }
        ],
        // 封面图片上传
        title_pic: '',
        photos: [],
        comment: ''
      },
      this.$emit('close', false)
    }
  }
}
</script>
<style lang='less' scoped>
/deep/ .el-dialog.signupDialog {
  width: 1334px!important;
  position: absolute;
  top: 40px;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  padding: 70px 80px 80px 80px!important;
  border-radius: 30px;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
    position: relative;
    .product-box {
      padding: 34px;
      border: 1px solid #E3E3E3;
      border-radius: 32px;
      margin: 70px auto 50px;
      position: relative;
      .products-template {
        display: flex;
        flex-direction: row;
        .products-content {
          display: flex;
          flex:1;
          flex-direction: column;
        }
        .operatBtn {
          width: 182px;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            margin-top: 45px;
            cursor: pointer;
          }
        }
      }
      &::before {
        content: '*';
        position: absolute;
        top: -20px;
        left: 0px;
        color: #E83636;
        font-size: 30px;
      }
    }
    .first-floor {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 25px;
      .label {
        flex: 1;
        padding: 0 10px;
        border-radius: 26px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        .title {
          height: 50px;
          line-height: 50px;
          white-space: nowrap;
          text-align: left;
          font-size: 24px;
          font-family: FZLanTingHeiS-DB-GB;
          font-weight: 400;
          margin-bottom: 15px;
          &.required {
            position: relative;
            &::before {
              content: '*';
              position: absolute;
              top: 2px;
              left: -15px;
              color: #E83636;
            }
          }
        }
        &:nth-of-type(2) {
          margin-left: 20px;
        }
        .mobilecode {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          border: 1px solid #B8D4B4;
          border-radius: 26px;
          .el-input__inner {
            border: 0;
          }
        }
        .radioBox {
          width: 100%;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .el-radio {
            display: flex;
            align-items: center;
          }
          .el-radio__label {
            font-size: 24px;
            font-family: FZLanTingHeiS-DB-GB;
            font-weight: 400;
            color: #666666;
          }
        }
        .el-radio__input {
          width: 29px;
          height: 29px;
          .el-radio__inner {
            width: 100%;
            height: 100%;
          }
          &.is-checked {
            &+.el-radio__label {
              color: #4E8B46;
            }
            .el-radio__inner {
              background: #4E8B46;
              border-color: #4E8B46;
              &:after {
                width: 100%;
                height: 100%;
                content: '\2714';
                font-size: 30px;
                color: #fff;
                background-color: #4E8B46;
              }
            }
          }
        }
        .el-cascader, .el-select, .el-input {
          width: 100%;
          input {
            background: #F5F8F4;
          }
        }
        .el-textarea {
          textarea {
            border: 2px solid #B8D4B4;
            border-radius: 32px;
            font-size: 24px;
            font-family: FZLanTingHeiS-R-GB;
            font-weight: 400;
            color: #999999;
          }
        }
        .el-input__inner {
          width: 100%;
          outline: none;
          font-size: 24px;
          font-family: FZLanTingHeiS-R-GB;
          font-weight: 400;
          color: #000;
          border: 1px solid #B8D4B4;
          border-radius: 26px;
          &::placeholder {
            font-size: 24px;
          }
        }
        .codeBtn {
          width: 160px;
          height: 44px;
          background: #4E8B46;
          border: 1px solid #4E8B46;
          border-radius: 22px;
          color: #fff;
          margin-right: -7px;
          font-size: 16px;
          font-family: FZLanTingHeiS-R-GB;
          font-weight: 400;
          color: #FFFFFF;
          :hover {
            color: #fff;
          }
          &.is-disabled {
            background: #ccc;
            border-color: #ccc;
          }
        }
        .image-box {
          display: flex;
          justify-content: flex-start;
          justify-content: flex-start;
          flex-wrap: wrap;
          .img-content {
            width: 247px;
            height: 247px;
            border-radius: 9px;
            margin-right: 20px;
            margin-bottom: 20px;
            position: relative;
            .close-icon {
              width: 38px;
              height: 38px;
              position: absolute;
              top: -11px;
              right: -9PX;
              cursor: pointer;
            }
          }
          .card {
            display: flex;
            flex-direction: row;
            width: 247px;
            height: 247px;
            border-radius: 9px;
            margin-right: 20px;
            margin-bottom: 20px;
            object-fit: cover;
          }
        }
        .visiting-card-uploader {
          width: 247px;
          height: 247px;
          display: flex;
          justify-content: center;
          align-items: center;
          .el-upload {
            width: 100%;
            height: 100%;
            display: flex;
            border-radius: 9px;
            background: #F2F2F2;
            overflow: hidden;
            text-align: center;
            position: relative;
            .card {
              width: 100%;
              height: 100%;
              display: block;
              object-fit: cover;
              vertical-align: middle;
            }
            .card-default {
              width: 86px;
              height: 74px;
              object-fit: cover;
              vertical-align: middle;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }
        }
        &.anotherlabel {
          height: auto;
          align-items: flex-start;
        }
      }
      &.anotherfloor {
        align-items: flex-start;
      }
      &.rowfloor {
        .label {
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          .title {
            margin: 0;
          }
          .el-rate {
            height: auto;
            .el-rate__icon {
              font-size: 30px!important;
            }
            .el-icon-star-on {
              
            }
          }
        }
      }
    }
    .signupBtn {
      width: 100%;
      height: 97px;
      background: #4E8B46;
      border-radius: 32px 32px 32px 32px;
      font-size: 45px;
      font-family: FZLanTingHeiS-DB-GB;
      font-weight: 400;
      color: #FFFFFF;
      margin: 80px auto 0;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      -webkit-user-select: none;
      .el-icon-loading {
        font-size: 45px!important;
      } 
    }
  }
}
</style>